import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageSquareHeart, Send } from "lucide-react";
import { sendExpectation } from "../lib/api";

// One-time post-login question. Any outcome (send or skip) marks the flag so it never shows again.
export default function ExpectationPopup({ userName, onDone }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const finish = async (payload) => {
    setBusy(true);
    try { await sendExpectation(payload); } catch { /* non-blocking */ }
    onDone();
  };

  return (
    <AnimatePresence>
      <motion.div className="fixed inset-0 z-[80] grid place-items-center bg-slate-900/40 backdrop-blur-[2px] px-4" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} data-testid="expectation-popup">
        <motion.form
          onSubmit={(e) => { e.preventDefault(); finish(text); }}
          initial={{ opacity: 0, y: 18, scale: 0.98 }} animate={{ opacity: 1, y: 0, scale: 1 }} transition={{ type: "spring", stiffness: 260, damping: 24 }}
          className="w-full max-w-md rounded-3xl bg-white shadow-[0_30px_80px_-30px_rgba(15,23,42,0.45)] ring-1 ring-slate-200 p-7"
        >
          <div className="w-11 h-11 rounded-2xl grid place-items-center text-white" style={{ background: "linear-gradient(115deg, #4A3BFA, #7A6CFF)" }}><MessageSquareHeart size={20} /></div>
          <h2 className="mt-4 text-xl font-bold tracking-tight text-slate-900">{userName ? `${userName.split(" ")[0]}, ` : ""}o que você espera dessa ferramenta?</h2>
          <p className="mt-1 text-[13px] text-slate-500">Uma frase basta. Isso ajuda a gente a construir o Basiq do jeito que você precisa.</p>
          <textarea
            autoFocus value={text} onChange={(e) => setText(e.target.value)} rows={3} maxLength={1000}
            placeholder="Ex.: fechar orçamentos mais rápido pelo WhatsApp…"
            className="mt-4 w-full rounded-2xl border border-slate-200 bg-slate-50 focus:bg-white focus:border-slate-900 outline-none px-4 py-3 text-[14px] text-slate-800 resize-none transition-colors"
            data-testid="expectation-text"
          />
          <div className="mt-4 flex items-center justify-between gap-3">
            <button type="button" onClick={() => finish("")} disabled={busy} className="text-[13px] text-slate-400 hover:text-slate-700 transition-colors" data-testid="expectation-skip">Agora não</button>
            <button type="submit" disabled={busy || !text.trim()} className="inline-flex items-center gap-2 h-11 px-5 rounded-full bg-slate-900 text-white text-[14px] font-semibold hover:bg-slate-800 transition-all hover:scale-[1.02] active:scale-95 disabled:opacity-40" data-testid="expectation-submit">
              <Send size={15} /> Enviar
            </button>
          </div>
        </motion.form>
      </motion.div>
    </AnimatePresence>
  );
}
